import axios from "axios";

export const setPaisState = (payload) => {
  return {
    type: "SET_PAIS_STATE",
    payload,
  };
};

export const setPaisSelectedTemplate = (payload) => {
  return {
    type: "SET_PAIS_SELECTED_TEMPLATE",
    payload,
  };
};

export const setSavePaisSelectedTemplate = (payload) => {
  return {
    type: "SET_SAVE_PAIS_SELECTED_TEMPLATE",
    payload,
  };
};

export const setEnlargeGrid = (payload) => {
  return {
    type: "SET_ENLARGE_GRID",
    payload,
  };
};

export const addProductRow = (payload) => {
  return {
    type: "ADD_PRODUCT_ROW",
    payload,
  };
};

export const setProductRows = (payload) => {
  return {
    type: "SET_PRODUCT_ROWS",
    payload,
  };
};

export const handleLoadPaisTemplates =
  (openModal) => async (dispatch, getState) => {
    try {
      dispatch(setPaisState({ templateLoading: true }));

      const state = getState();
      const currentSession = state.sessions?.currentSession;
      const { selectedRow } = state.myPermitsComponent;

      const resp = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/nocApi/data/get-saved-projects`,
        {
          currentSession: currentSession,
          getPais: true,
          city: selectedRow?.city,
          county: selectedRow?.county,
        },
        { withCredentials: true }
      );

      await dispatch({
        type: "FIRST_ADD_SAVED_PROJECTS",
        payload: resp?.data,
      });

      // if (openModal) {
      //   dispatch(setPaisState({ openModal: true }));
      // } else {
      //   dispatch(
      //     setPaisState({
      //       useTemplate: true,
      //       tempContinue: false,
      //       addNewWaiting: true,
      //     })
      //   );
      // }
    } catch (error) {
    } finally {
      dispatch(setPaisState({ templateLoading: false }));
    }
  };
